import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useManufacturer, Manufacturer } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<Manufacturer>
      useData={useManufacturer}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
